import _ from "lodash"

export default function parseJsonData(dataJson) {
  const dataParsed = JSON.parse(dataJson)
  const dataTransform = _.reduce(
    dataParsed,
    (acc, blocks, idStamp) => {
      const allBlockValues = _.reduce(
        blocks,
        (acc, block) => {
          const {values, ...rest} = block
          return {
            ...values,
            ...rest,
            ...acc,
          }
        },
        {}
      )
      return [
        ...acc,
        {
          idStamp,
          ...allBlockValues,
        },
      ]
    },
    []
  )
  return dataTransform
}
